import React, { Component } from 'react';
import { isNullUndefinedEmpty, isValidEmail } from '../../utils/validations';
import * as authService from '../../services/auth/auth-service';
import { Link } from 'react-router-dom';
import { noteForgotPassword } from "../../common/config";
import * as Loader from '../../common/common';
import DropDown from '../../components/form-controls/dropdown';
import { defaultListItem, ddUserType } from '../../common/const';

export default class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }
    state = {
        forgetPassword: {
            email: '',
            userType:'',
        },
        msg: '',
        error:'',
        validationErrors: {
            emailError: '',
            userTypeError:'',
        },
    }
    onChange(e) {
        let validationErrors = Object.assign({}, this.state.validationErrors);
        const value = e.target.value;
        const name = e.target.name;
        this.setState({
            forgetPassword: {
                ...this.state.forgetPassword,
                [name]: value
            },
            msg: '',
            error:'',
        });
        if (name === 'email') {
            if (isNullUndefinedEmpty(value)) {
                validationErrors.emailError = 'Please provide Email address'
            }
            else {
                validationErrors.emailError = ''
            }
        }
        this.setState({
            validationErrors: validationErrors
        })
    }
    async onSubmit() {
        Loader.showLoader();
        let {email,userType} = this.state.forgetPassword
        let validationErrors = Object.assign({}, this.state.validationErrors);
        let validationFlag = false;
        if (isNullUndefinedEmpty(email)) {
            validationErrors.emailError = 'Please provide Email address'
            validationFlag = true;
        }
        else if (!isValidEmail(email)) {
            validationErrors.emailError = 'Please provide a valid Email address'
            validationFlag = true;

        }
        else {
            validationErrors.emailError = ''
        }
        if (!userType) {
            validationErrors.userTypeError = "Please select User Type";
            validationFlag = true;
          } else {
            validationErrors.userTypeError = ''
          }
        this.setState({
            validationErrors: validationErrors
        })
        if (validationFlag === false) {

            let { response, err } = await authService.forgetPassword(this.state.forgetPassword);
            Loader.hideLoader();
            if (err) {
                this.setState({
                    error: err,
                    msg: ''
                })
            } else if (response.data && response.data.err) {
                this.setState({
                    error: response.data.err,
                    msg: ''
                })
            } else {
                this.setState({
                    forgetPassword: {},
                    msg: response.data.msg,
                    error: '',
                })
            }
        }
        else {
            Loader.hideLoader();
        }
    }
    render() {
        return (
            <React.Fragment>
                <div className="app flex-row align-items-center">
                    <div className="container">
                        <div style={{ textAlign: "center" }}>
                            <img src="/images/logo.jpg" width="201" height="40" alt="logo" />
                        </div>
                        
                        <p></p>
                        <div className="row justify-content-center">
                            <div className="col-md-6">
                                <div className="card mx-4">
                                    <div className="card-body p-4">
                                        <form>
                                            <h1>Forget Password</h1>
                                            <div className="input-group mb-3" style={{ color: '#66CCCC' }}>
                                                {this.state.msg}
                                            </div>
                                            {this.state.error ? <p className="text" style={{ color: "red" }}>{this.state.error}</p> : null}
                                            <div>
                                                <DropDown label='User Type' name='userType' required='true' value={this.state.forgetPassword.userType || ""} error={this.state.validationErrors.userTypeError} onChange={this.onChange} defaultItem={defaultListItem} list={ddUserType} valProp="value" textProp="name" />
                                            </div>
                                            <div className="input-group mb-3">
                                                <div className="input-group-prepend">
                                                    <span className="input-group-text">
                                                        <i className="icon-envelope"></i>
                                                    </span>
                                                </div>
                                                <input className={this.state.validationErrors.emailError ? "is-invalid form-control" : "form-control"} type="text" placeholder="Email" value={this.state.forgetPassword.email || ''} name="email" onChange={this.onChange} autoComplete="off" />
                                            </div>
                                            <div className="form-group">
                                                <span className="error-msg">{this.state.validationErrors.emailError}</span>
                                            </div>
                                            <span className="text-muted">Note : {noteForgotPassword}</span>
                                            <div>&nbsp;</div>
                                            <button className="btn btn-block btn-success" type="button" onClick={this.onSubmit}>Submit</button>
                                        </form>
                                        <div style={{ textAlign: "center" }}>
                                            <Link to="/Login">Back to Login</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
